import { inject } from 'inversify';

import CONSTANTS from '../helpers/constants';

import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { UnitEte } from '@/services/signalr/MessageTypes/UnitEte';
import { Signalr } from '@/services/signalr/Signalr';
import { EteStore } from '@/stores/EteStore';
import type { IGeoPosition } from 'types/api/IGeoPosition';
import type { IUnitEteRespMsg } from 'types/api/messages/IUnitEteRespMsg';

@SignalrListener
@service(EteManager)
export class EteManager {
  @inject(EteStore) protected eteStore: EteStore;
  @inject(Signalr) protected signalr: Signalr;
  @inject(Logger) protected logger: Logger;

  private getSegments(unitPosition: IGeoPosition, tripPosition: IGeoPosition) {
    if (!unitPosition || !tripPosition) {
      return null;
    }

    const origin = {
      Lat: unitPosition.lat,
      Lng: unitPosition.lng,
    };

    const destination = {
      Lat: tripPosition.lat,
      Lng: tripPosition.lng,
    };

    return [{ PositionStart: origin, PositionEnd: destination }];
  }

  find(id: string) {
    return this.eteStore.find(id);
  }

  async onUnitEteReqMsg(
    tripId: string,
    unitPosition: IGeoPosition,
    tripPosition: IGeoPosition,
  ) {
    const segments = this.getSegments(unitPosition, tripPosition);
    if (!segments) {
      return;
    }

    try {
      await this.signalr.invoke(UnitEte, {
        contextKey: CONSTANTS.UI.CONTEXTS.TRIP_DETAILS,
        correlationKey: tripId,
        segments,
      });
    }
    catch (error) {
      this.logger.error(error, { tags: { signalr: 'UnitEteReqMsg' } });
    }
  }

  @SignalrMessage('UnitEteRespMsg')
  protected async onUnitEteRespMsg(message: IUnitEteRespMsg) {
    const segment = message.segments?.[0];
    if (!segment) {
      return;
    }

    this.eteStore.update({
      tripId: message.correlationKey,
      ...segment,
    });
  }
}
